export default {
  entities: {
    notification: {
      notificationsList: {
        headers: ['Загаловок', 'Уведомление', 'Получено'],
      },
    },
  },
};
